import React from 'react';
import { AccordionWrapper, CommentsWrapper } from 'react-lib/dist/components-es';
import { useTranslation } from 'react-i18next';
import { ActionCommentDTO } from '@behavior/activity/dto/ActionCommentDTO';

type Props = {
  actionComments?: ActionCommentDTO[];
  addComment: (comment: string[]) => void;
};

function CommentsContainer({ actionComments, addComment }: Props) {
  const comments = actionComments
    ?.map(comment => ({
      comment: comment.description,
      creator: comment.createUser,
      createdDate: comment.createDte,
    }))
    .sort((a, b) => new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime());

  const { t } = useTranslation();

  if (!comments) {
    return null;
  }

  return (
    comments && (
      <AccordionWrapper
        collapsed={true}
        accordionTitle={
          t('action.report.details.comments.title') +
          (comments.length > 0 ? ` (${comments.length})` : '')
        }
        className="actionCommentsAccordion"
        render={() => (
          <div className="actionCommentsContainer">
            <CommentsWrapper
              comments={comments}
              canAddComment
              inContainer
              saveCommentAction={(comment: string[]) => addComment(comment)}
              t={t}
            />
          </div>
        )}
      />
    )
  );
}

export default CommentsContainer;
